<tt-page *ngIf="!!menu">
    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-3 p-5" ttHeading="h_info">
            <tt-input ttLabel="domobjecttype_keyno" [ttModel]="menu.domobjecttype_keyno" ttReadonly></tt-input>
            <tt-input ttLabel="domobjecttype_name" [ttModel]="menu.domobjecttype_name" ttReadonly></tt-input>
            <tt-datetime ttLabel="reg_datetime" [ttModel]="menu.reg_datetime" ttReadonly></tt-datetime>
            <tt-input ttLabel="reg_by_portal_user_keyno" [ttModel]="menu.reg_by_portal_user_keyno" ttReadonly></tt-input>
            <tt-input ttLabel="domobjecttypetype_id" [ttModel]="menu.domobjecttypetype_id" ttReadonly></tt-input>
        </tt-card>

        <tt-card class="col-xs-12 col-md-3 p-5" ttHeading="h_functions">
            <tt-button-goto [ttText]="'domobjecttypemenu_edit'" [ttGoto]="'domobjecttype'" [ttGotoParms]="{ domobjecttype_keyno: menu.domobjecttype_keyno }"></tt-button-goto>
        </tt-card>
    </div>

    <tt-grid *ngIf="!!grid" class="p-5 flex-1" [(ttOptions)]="grid"></tt-grid>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0 height-full">
    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-3 p-5">
            <tt-page-heading class="col-xs-12 sp-0" tt-model="h_info" tt-translate="true"></tt-page-heading>
            <div class="k-hr col-xs-12 sp-0"></div>
            <tt-input class="col-xs-12 sp-0" tt-label="domobjecttype_keyno" tt-model="vm.model.menu.domobjecttype_keyno" tt-change="vm.model.menu.domobjecttype_keyno = $value" tt-readonly="true"></tt-input>
            <tt-input class="col-xs-12 sp-0" tt-label="domobjecttype_name" tt-model="vm.model.menu.domobjecttype_name" tt-change="vm.model.menu.domobjecttype_name = $value" tt-readonly="true"></tt-input>
            <tt-datetime class="col-xs-12 sp-0" tt-label="reg_datetime" tt-model="vm.model.menu.reg_datetime" tt-change="vm.model.menu.reg_datetime = $value" tt-date-options="{ date: {show: true, disabled: false, align: 'right'}, hour: {show: true, disabled: false, align: 'right'}, minute: {show: true, disabled: false, align: 'right', interval: 1}}" tt-readonly="true"></tt-datetime>
            <tt-input class="col-xs-12 sp-0" tt-label="reg_by_portal_user_keyno" tt-model="vm.model.menu.reg_by_portal_user_keyno" tt-change="vm.model.menu.reg_by_portal_user_keyno = $value" tt-readonly="true"></tt-input>
            <tt-input class="col-xs-12 sp-0" tt-label="domobjecttypetype_id" tt-model="vm.model.menu.domobjecttypetype_id" tt-change="vm.model.menu.domobjecttypetype_id = $value" tt-readonly="true"></tt-input>
        </tt-card>

        <tt-card class="col-xs-12 col-md-3 p-5">
            <tt-page-heading class="col-xs-12 sp-0" tt-model="h_functions" tt-translate="true"></tt-page-heading>
            <div class="k-hr col-xs-12 sp-0"></div>
            <tt-button-goto class="col-xs-12 sp-0" tt-text="domobjecttypemenu_edit" tt-goto="domobjecttype" tt-goto-parms="{ domobjecttype_keyno: vm.model.menu.domobjecttype_keyno }" tt-text-align="left"></tt-button-goto>
        </tt-card>
    </div>

    <tt-grid ng-if="vm.model.gridReady" class="col-xs-12 p-5 flex-1" tt-options="vm.grid"></tt-grid>
</tt-page>-->
